<ngx-skeleton-loader *ngIf="initialLoading" count="5"
  [theme]="{ 'border-radius': '8px', height: '60px', margin: '10px 40px 0px', width: 'calc(100% - 80px)' }"></ngx-skeleton-loader>
<div *ngIf="!initialLoading" #top class="container">
  <div *ngIf="!fromSearch || (fromSearch && searchShortcuts.length > 0)" infiniteScroll
    [fromRoot]="listService.fromRoot" (scrolled)="listService.getList()"
    [infiniteScrollDistance]="listService.scrollDistance" [infiniteScrollThrottle]="listService.scrollThrottle"
    [infiniteScrollContainer]="listService.scrollContainer"
    [infiniteScrollDisabled]="this.scrollDisabled || listService.scrollDisabled">
    <div class="download-banner" *ngIf="!fromSearch">
      <app-download-banner></app-download-banner>
    </div>

    <div class="manage-shortcut">
      <h3 style="display: flex; justify-content: flex-start; align-items: center; gap: 5px; margin-left: 0">
        <vng-checkbox *ngIf="shortcuts.length" color="primary" [ngClass]="{
            'checkbox-frame': noShortcutChecked,
            'blur-effect': listService.isLoading
          }" [(ngModel)]="allShortCutChecked" (ngModelChange)="updateCheckList(allShortCutChecked, -1)"
          style="width: 24px; height: 24px; padding-bottom: 10px"></vng-checkbox>
        <span *ngIf="!fromSearch">Manage</span>
        <span *ngIf="fromSearch">FlyCuts</span>
        <!-- P8: single-tone heading, matching its five sibling page headings
             (and master) — the bold purple emphasis was a migration-only
             deviation. -->
        <span *ngIf="!fromSearch">My FlyCuts</span>
        <vng-icon name="help_center" [outline]="false" color="purple" class="help-icon"
          ngbPopover="These are all your created FlyCuts, browse by category or view them all. Remember to always preview them once created.">
        </vng-icon>
      </h3>

      <div class="manage-shortcut-actions">
        <button class="white-icon hide-on-mobile" *ngIf="isAnyShortcutChecked" id="deleteBulkShortcut" type="button"
          vng-button variant="primary" (click)="deleteBulkShortcut()" aria-label="delete">
          <vng-icon name="delete" [outline]="false" class="white-icon" vngTooltip="Delete FlyCut"
            vngTooltipPosition="top">
          </vng-icon>
        </button>
        <!-- V3-04: master drew the list-header Share as the orange outline variant.
             variant="secondary" is the ink (#2d283a) label/border pair, and vng-icon's
             default color="plum" out-specifies the button's colour either way — so the
             icon needs color="inherit" to follow the accent label. -->
        <button onclick="this.blur()" *ngIf="shortcuts.length || (searchShortcuts && fromSearch)" type="button"
          vng-button variant="outline" (click)="share()">
          <vng-icon name="share" [outline]="false" color="inherit"></vng-icon> Share
        </button>
        <!-- V4-03: same family as V3-04 one button up — vng-icon's `:host` default
             color="plum" out-specifies the primary button's white label, so the
             leading plus rendered #2A1E36 on the orange fill (two foreground
             tokens in one control). vng-icon also has no intrinsic font-size, so
             it inherited the button's 14px and the plus ink came out 8x8 against
             master's 14x14. `[size]="24"` is master's mat-icon size (24px em ->
             14x14 of ink, measured in artifacts/old/shortcuts_all). -->
        <button id="addNewShortcut" type="button" vng-button variant="primary" (click)="addNewShortcut()">
          <vng-icon name="add" [outline]="false" color="inherit" [size]="24"></vng-icon> Add FlyCut
        </button>
      </div>
    </div>

    <vng-divider spacing="none"></vng-divider>

    <!-- </div> -->

    <app-empty-state *ngIf="(!listService.isLoading && !shortcuts.length) || (!searchShortcuts && fromSearch)"
      heading="No FlyCuts Added" subtext="Let get you started."></app-empty-state>

    <div [ngClass]="listService.isLoading ? 'blur-effect' : ''" *ngIf="shortcuts.length">
      <!-- R15: mat-accordion multi -> plain div (all fe accordions are `multi`,
           so independent vng-expansion-panels need no coordination code). -->
      <div class="vng-accordion">
        <div style="display: flex" *ngFor="let shortcut of shortcuts; let i = index">
          <div style="display: flex; justify-content: flex-start; align-items: center">
            <vng-checkbox color="primary" style="margin-right: 3px" [ngClass]="{ 'checkbox-frame': noShortcutChecked }"
              [(ngModel)]="shortcut.checked" (ngModelChange)="updateCheckList(shortcut.checked, i)"></vng-checkbox>
            <p class="number" style="display: inline-block; background-color: unset">
              {{ i + 1 }}
            </p>
          </div>
          <vng-expansion-panel [id]="shortcut.mappedId" class="shortcut-panel"
            [expanded]="panelExpandState[shortcut.id]" (opened)="panelOpenState[shortcut.id] = true"
            style="flex: 1; margin-left: 0">
            <!-- T3: shared collapsed-row content (see flymsg-row-header.component.ts
                 class doc). titleHtml/descriptionHtml keep the fromSearch-gated
                 HighlighterPipe usage identical to the pre-T3 markup. -->
            <app-flymsg-row-header vngExpansionHeader [name]="shortcut.shortcut"
              [title]="!fromSearch ? shortcut.title : ''"
              [titleHtml]="fromSearch ? (shortcut.title | highlighter : searchText : 'partial') : null"
              [description]="!fromSearch ? (shortcut.first_line || 'First line of content appears here...') : ''"
              [descriptionHtml]="
                fromSearch
                  ? (shortcut.first_line || 'First line of content appears here...'
                    | highlighter : searchText : 'partial')
                  : null
              " [usageCount]="shortcut.version_counts || 0"
              (usageClick)="openVersionHistory(shortcut)"></app-flymsg-row-header>

            <!-- T3: shared expanded-row content. The TinyMCE <editor> stays
                 fully host-owned (apiKey/init/autosave/versioning wiring
                 untouched) and is projected in via [editor]. -->
            <app-flymsg-row-editor [flyCutValue]="shortcut.shortcut"
              (flyCutValueChange)="shortcut.shortcut = $event; onChangeContent(i)"
              [flyCutError]="!shortcut.shortcut ? 'Failed to save. FlyCut is required' : ''"
              [tryItOutHeapAttr]="'fms-shortcuts-try-it-out-button-' + shortcut.shortcut"
              (tryItOut)="tryShortcutModal(shortcut)" [titleValue]="shortcut.title"
              (titleValueChange)="shortcut.title = $event; onChangeContent(i)"
              [titleError]="!shortcut.title ? 'Failed to save. Title is required' : ''"
              [versionCount]="shortcut.version_counts || 0" (versionClick)="openVersionHistory(shortcut, true)"
              [actionOptions]="rowActionOptions" (actionSelected)="onRowAction(shortcut, $event)"
              [errors]="shortcut.errors" [isSaving]="currentIndex === i && isSaving"
              (duplicate)="duplicateFlycut(shortcut)" (changeCategory)="changeCategory(shortcut)"
              (delete)="deleteShortcut(shortcut, i)">
              <editor editor [apiKey]="editorApiKey" [cloudChannel]="'8'" id="shortcut{{ shortcut.id }}"
                [init]="editorConfig" *ngIf="editorConfig && panelOpenState[shortcut.id]" [(ngModel)]="shortcut.html"
                (onInit)="setEditorManager($event)" (ngModelChange)="onChangeContent(i)"
                [ngModelOptions]="{ standalone: true }">
              </editor>
            </app-flymsg-row-editor>
          </vng-expansion-panel>
        </div>
      </div>
    </div>

    <div id="bottom-scroller-element" style="visibility: hidden">.</div>

    <div *ngIf="upScroll" class="scroll-top" #bottom
      style="display: flex; justify-content: flex-end; align-items: center">
      <button type="button" vng-button variant="ghost" class="no-color scroll-button"
        (click)="scrollService.scrollTo(top)" id="scroll-up">
        <svg-icon-sprite width="14px" height="14px" src="icon-ico-scroll-up"> </svg-icon-sprite>
      </button>
    </div>
  </div>
</div>